export const SESSION_CALCULATOR_NAME = 'calculator';

export type SESSION_CALCULATOR_TYPE = {
  amount: number;
  term: number;
};

export const getDefaultCalculatorFromSession = () => {
  const sessionCalculatorData = sessionStorage?.getItem(
    SESSION_CALCULATOR_NAME,
  );
  const sessionCalculatorDataParsed: SESSION_CALCULATOR_TYPE | undefined =
    sessionCalculatorData && JSON.parse(sessionCalculatorData);
  return sessionCalculatorDataParsed;
};
